module.exports = __webpack_public_path__ + "img/35.ba05832c.jpg";